import { Input } from 'antd'
import styled, { css } from 'styled-components'

const StyledLabelLegendsInput = styled(Input)`
  width: 100%;
  ${props =>
    props.isSuggestedByAi &&
    css`
      border-color: #1890ff;
    `};
  ${props =>
    props.isFromUnknownWords &&
    css`
      border-color: #ff0000;
    `};
  ${props =>
    props.isChoice &&
    css`
      border-color: #044d02;
    `};
`

export default StyledLabelLegendsInput
